module.exports = __webpack_public_path__ + "img/ssyx_07.a50df9ef.jpg";